import Matana1 from '../Matana/matana (1).webp'
import Matana2 from '../Matana/matana (2).webp'
import Matana3 from '../Matana/matana (3).webp'
import Matana4 from '../Matana/matana (4).webp'
import Matana5 from '../Matana/matana (5).webp'
import Matana6 from '../Matana/matana (6).webp'



const Matanaimages =[
Matana1,Matana2,Matana3,Matana4,Matana5,Matana6
]

export default Matanaimages;